import cn from 'classnames';
import { useIntl } from 'react-intl';
import { ButtonUI, ContextualMenu } from 'sonata-react-components';

import ClearAllButton from './ClearAllButton';
import FilterPanel from './FilterPanel';
import FilterSelectors from './FilterSelectors';

import './filters.scss';

import type { FilterConfig, FilterPanelConfig } from './filters.types';

type Props = {
  /** Flat mode: number of applied filters, for the trigger badge and the clear button. */
  activeCount?: number;
  id: string;
  /** Flat list of selectors. */
  filters?: FilterConfig[];
  /** Flat mode: clears every filter. */
  onClear?: () => void;
  /** Location and attributes sections; takes over `filters`. */
  panel?: FilterPanelConfig;
};

function Filters({ activeCount = 0, id, filters = [], onClear, panel }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const appliedCount = panel ? panel.location.activeCount + panel.attributes.activeCount : activeCount;

  return (
    <div className="filters" id={id}>
      <ContextualMenu closeOnClick={false} id={'filtersPanel-menu'} placement="bottom-start">
        <ContextualMenu.Trigger>
          <ButtonUI
            badge={appliedCount > 0 ? { content: appliedCount } : false}
            icon="fa-regular fa-sliders"
            id={'filters-trigger'}
            size="ultraSmall"
            type="secondary"
          />
        </ContextualMenu.Trigger>
        <ContextualMenu.Item>
          <div className={cn('filters__panel', { 'filters__panel--sections': panel })}>
            {panel ? (
              <FilterPanel panel={panel} />
            ) : (
              <>
                <div className="filters__header">
                  <div className="filters__title">
                    {formatMessage({
                      defaultMessage: 'Filter by:',
                      id: 'multiFlightListsMap.filters.title'
                    })}
                  </div>
                  <ClearAllButton disabled={!onClear || appliedCount === 0} onClear={onClear} />
                </div>
                <div className="filters__separator" />
                <FilterSelectors filters={filters} />
              </>
            )}
          </div>
        </ContextualMenu.Item>
      </ContextualMenu>
    </div>
  );
}

export default Filters;
